module.exports = __webpack_public_path__ + "img/07_shimizu_21.658297fe.jpg";